<div class="progress-bar-container">
    <div class="progress-bar"
         [ngStyle]="{'width': progress + '%', 'background-color':color}">
    </div>
    <div class="progress-text" [ngStyle]="{'left': + progress - 10 + '%'}"> {{progress}}%</div>
</div>
